/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login
 */

import authService from '@/services/auth';
import store from '@/store';
import { loadRecaptcha } from '@/utils/recaptcha';

export default {
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
      captchaToken: '',
      captchaWidgetId: null,
      loadingCaptcha: false,
      submitting: false,
    };
  },

  computed: {
    recaptchaSiteKey() {
      return process.env.RECAPTCHA_SITE_KEY;
    },
    hasRecaptcha() {
      return !!this.recaptchaSiteKey;
    },
    submitDisabled() {
      return this.submitting || (this.hasRecaptcha && !this.captchaToken);
    },
  },

  mounted() {
    store.dispatch('general/resetMessages');

    if (this.hasRecaptcha) {
      this.initializeRecaptcha();
    }
  },

  methods: {
    async initializeRecaptcha() {
      this.loadingCaptcha = true;

      try {
        const grecaptcha = await loadRecaptcha();

        this.$nextTick(() => {
          if (!this.$refs.recaptcha || this.captchaWidgetId !== null) {
            return;
          }

          this.captchaWidgetId = grecaptcha.render(this.$refs.recaptcha, {
            sitekey: this.recaptchaSiteKey,
            callback: token => this.onCaptchaVerified(token),
            'expired-callback': () => this.onCaptchaExpired(),
            'error-callback': () => this.onCaptchaError(),
          });
        });
      } catch (error) {
        store.dispatch('general/setMessages', [this.$t('auth.recaptchaLoadFailed')]);
      } finally {
        this.loadingCaptcha = false;
      }
    },
    onCaptchaVerified(token) {
      this.captchaToken = token;
    },
    onCaptchaExpired() {
      this.captchaToken = '';
    },
    onCaptchaError() {
      this.captchaToken = '';
      store.dispatch('general/setMessages', [this.$t('auth.recaptchaError')]);
    },
    resetCaptcha() {
      this.captchaToken = '';

      if (this.hasRecaptcha && window.grecaptcha && this.captchaWidgetId !== null) {
        window.grecaptcha.reset(this.captchaWidgetId);
      }
    },
    async onSubmit(form) {
      store.dispatch('general/resetMessages');

      if (this.hasRecaptcha && !this.captchaToken) {
        store.dispatch('general/setMessages', [this.$t('auth.recaptchaRequired')]);
        return;
      }

      const payload = {
        ...form,
      };

      if (this.hasRecaptcha) {
        payload.recaptchaToken = this.captchaToken;
        payload['g-recaptcha-response'] = this.captchaToken;
      }

      this.submitting = true;

      try {
        await authService.login(payload);
      } finally {
        this.submitting = false;

        if (this.hasRecaptcha) {
          this.resetCaptcha();
        }
      }
    },
  },

  components: {
    VLayout: require('@/layouts/login/login.vue'),
    VAlert: require('@/components/alert/alert.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/pages/user/login/index/index.js